var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 10.492c-1.23.027-2.379-.355-3.363-1.066v4.894c0 1.86-1.149 3.5-2.899 4.157a4.41 4.41 0 0 1-4.894-1.23 4.479 4.479 0 0 1-.574-5.06c.875-1.613 2.68-2.515 4.539-2.269v2.46a2.064 2.064 0 0 0-2.297.74c-.492.737-.492 1.694.027 2.405a2.038 2.038 0 0 0 2.27.739 2.052 2.052 0 0 0 1.421-1.942V4.75h2.407c0 .219 0 .41.054.629a3.233 3.233 0 0 0 1.477 2.187 3.28 3.28 0 0 0 1.832.547v2.38Z"
  })));
};

export default SvgTiktok;